export default "__VITE_ASSET__bRNLzFIW__"